export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const SET_LOADING_TRUE = "SET_LOADING_TRUE";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";

export const REGISTRATION_START = "REGISTRATION_START";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_ERROR = "REGISTRATION_ERROR";

export const CLEAR_MESSAGES = "CLEAR_MESSAGES";


export const SET_USER_UPDATE_DETAILS = "SET_USER_UPDATE_DETAILS";


export const MENU_OVERLAY_ON = 'MENU_OVERLAY_ON';
export const MENU_OVERLAY_OFF = 'MENU_OVERLAY_OFF';
export const ACTIVE_LINK = 'ACTIVE_LINK';




